import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Red Hat Certified Virtualization Administrator RHCVA</h1>
          </div>
          <div className="imgSection py-4">
            <img
              src={require("../../../images/courses/Virtualization.png")}
              alt=""
            />
          </div>
          <div className="heading">
            <h3>Red Hat Certified Virtualization Administrator RHCVA </h3>

            <br />
            {/*  */}
            <h4 style={{ color: "blue" }}>
              Overview For Red Hat Certified Virtualization Administrator RHCVA{" "}
            </h4>
            <ul>
              <li>
                Red Hat Certified Virtualization Administrator (RHCVA) RH 318
                certification is a performance-based certification like all
                other Red Hat Certifications. Red Hat certified virtualization
                administrator RHCVA provides best IT efficiency and reduces
                capital & operational costs, by running multiple operating
                systems within a single server system. Due to its Cost and
                operational efficiency, Red Hat certified virtualization
                administrator RHCVA reached in favorite list of data centres and
                other industries. Hands-on practical provides confidence to
                successfully manage virtual environment.Red Hat certified
                virtualization administrator RHCVA is the most popular
                certification among virtualization technology.
              </li>
            </ul>
            {/*  */}
            <h4 style={{ color: "blue" }}>
              Prerequisites for Red Hat Certified Virtualization Administrator
              RHCVA
            </h4>
            <ul>
              <li>
                AIX, Solaris, Microsoft system administrators who are
                responsible for managing enterprise servers and are interested
                in learning how to manage large numbers of servers or virtual
                machines using Red Hat Enterprise Virtualization can attend this
                course. One advantage to RHCVA certification is that it is
                focused and comprises of only one module. You need to have very
                basic knowledge of UNIX/LINUX commands.
              </li>
            </ul>
            {/*  */}
            <h4 style={{ color: "blue" }}>
              Red Hat Certified Virtualization Administrator RHCVA Course
              Includes
            </h4>
            <ul>
              <li>Hands-on labs and exercises</li>
              <li>Two workstations per student</li>
              <li>Student materials, study aids,and handouts. </li>
              <li>Extra practice timing. </li>
              <li>Exam Orientation.</li>
            </ul>
            {/*  */}
            <h3 style={{ color: "blue" }}>
              Red Hat Certified Virtualization Administrator RHCVA Course
              Content:
            </h3>
            {/*  */}
            <h4>
              Unit 1: Introduction to Red Hat Enterprise Virtualization Platform
            </h4>
            <ul>
              <li>Red Hat Enterprise Linux Virtualization </li>
              <li>Introduction to KVM </li>
              <li>VirtIO drivers </li>
              <li>libvirt ,Virtual machine management with virsh </li>
            </ul>
            {/*  */}
            <h4>Unit 2: Advanced RHEL Virtualization</h4>
            <ul>
              <li>Managing virtual machines with RHN </li>
              <li>Defining VMs with libvirt XML </li>
              <li>Custom KVM network configuration </li>
              <li>Virtual Machine Migration </li>
              <li>Shared Storage </li>
              <li>iSCSI: Internet SCSI </li>
              <li>Accessing disk images from the host OS </li>
            </ul>
            {/*  */}
            <h4>Unit 3: Red Hat Enterprise Virtualization</h4>
            <ul>
              <li>RHEV for Servers architecture overview </li>
              <li>Red Hat Enterprise Virtualization Manager overview </li>
              <li>Red Hat Enterprise Virtualization Hypervisor overview </li>
              <li>Preparing a Windows Server for RHEV-M installation </li>
            </ul>
            {/*  */}
            <h4>Unit 4: RHEV Manager</h4>
            <ul>
              <li>Installing RHEV Manager </li>
              <li>The RHEV-M database </li>
              <li>Accessing the RHEV-M Admin Portal </li>
            </ul>
            {/*  */}
            <h4>Unit 5: RHEV Hyper visor</h4>
            <ul>
              <li>Introduction to RHEV-H </li>
              <li>RHEV-H deployment modes </li>
              <li>Installing RHEV-H </li>
              <li>Automated RHEV-H installation </li>
              <li>RHEV-H reconfiguration </li>
              <li>Upgrading RHEV-H </li>
              <li>Troubleshooting RHEV-H </li>
            </ul>
            {/*  */}
            <h4>Unit 6: RHEV Data Center</h4>
            <ul>
              <li>Data Center overview </li>
              <li>Host </li>
              <li>Storage Domains</li>
              <li>Clusters </li>
              <li>System Scheduler</li>
              <li>Logical networks</li>
              <li>Virtual machines</li>
              <li>Creating a New Data Center</li>
              <li>Creating a New Cluster</li>
              <li>Configuring storage</li>
            </ul>
            {/*  */}
            <h4>Unit 7: RHEV for Servers</h4>
            <ul>
              <li>Creating virtual servers</li>
              <li>Installing virtual servers</li>
              <li>Paravirtualized drivers for Windows</li>
              <li>PXE Installation and RHN/Cobbler</li>
              <li>Virtual Machine Migration</li>
              <li>High Availability for Guests</li>
              <li>RHN Entitlements and RHEV VMs</li>
            </ul>
            {/*  */}
            <h4>Unit 8: RHEV for Desktops</h4>
            <ul>
              <li>RHEV for Desktops architecture</li>
              <li>SPICE </li>
              <li>Creating virtual Desktops</li>
              <li>Installing Windows network VirtIO drivers</li>
            </ul>
            {/*  */}
            <h4>Unit 9: Snapshots and Templates</h4>
            <ul>
              <li>Image formats </li>
              <li>Image management </li>
              <li>Creating VM snapshots </li>
              <li>Creating templates </li>
              <li>Sealing a Windows template with Sysprep</li>
            </ul>
            {/*  */}
            <h4>Unit 10: Desktop Pools, Users and Portal</h4>
            <ul>
              <li>Creating and managing Desktop Pools</li>
              <li>Managing users</li>
              <li>Accessing the User Portal</li>
              <li>Accessing Virtual Desktops</li>
            </ul>
            {/*  */}
            <h4>Unit 11: Advanced RHEV</h4>
            <ul>
              <li>Using Export Storage domains </li>
              <li>Converting Virtual Machines with virt-v2v </li>
              <li>Importing converted Virtual Machines </li>
              <li>Using the Search Bar </li>
              <li>Using Tags </li>
              <li>Using the Monitoring Tools </li>
              <li>Using Log Collector </li>
            </ul>
            {/*  */}
            <h4>Unit 12: RHEV-Managed RHEL Hosts</h4>
            <ul>
              <li>Managed Red Hat Enterprise Linux hosts </li>
              <li>RHEV software for RHEL nodes </li>
              <li>Registering a RHEL node with RHEV </li>
              <li>Troubleshooting registration </li>
              <li>Performance tuning for RHEV </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
